import * as React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import * as Fuse from 'fuse.js';
import { findIndex } from 'lodash';
import { Card, Form, Notification } from '../';
import { addPermissionToUser, clearErrors } from '../../redux/actions/users';
import permissions from '../../data/permissions';
import fields from '../../data/fields';
import search from '../../data/search';

interface Props {
  users: any;
  userId: number;
  dispatch: Function;
}

interface State {
  resetForm: Function;
  items: any;
  search: string | boolean;
  valid: boolean;
}

class PermissionForm extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      resetForm: () => {},
      items: permissions,
      search: '',
      valid: false,
    };
    this.handleAddPermission = this.handleAddPermission.bind(this);
    this.handleFormDispatch = this.handleFormDispatch.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleItemClick = this.handleItemClick.bind(this);
  }

  handleAddPermission(data) {
    if (this.state.valid) {
      this.props
        .dispatch(addPermissionToUser(this.props.userId, data.permission || ''))
        .then((response) => {
          if (!response.error) {
            this.props.dispatch(clearErrors());
            this.state.resetForm();
          }
        });
    }
  }

  handleSearch(data) {
    this.setState({ search: data.permission || false, valid: false });
    if (data.permission) {
      const fuse = new Fuse(permissions, search.permissions as any);
      this.setState({ items: fuse.search(data.permission) });
      const index = findIndex(permissions, { name: data.permission });
      if (index !== -1) {
        this.setState({ valid: true });
      }
    } else {
      this.setState({ items: permissions });
      this.props.dispatch(clearErrors());
    }
  }

  handleFormDispatch(dispatch) {
    this.setState({
      resetForm: () => {
        dispatch(actions.change('permission.permission', ''));
      },
    });
  }

  handleItemClick(data) {
    this.setState({ valid: true }, () => {
      this.handleAddPermission({ permission: data.name });
    });
  }

  render() {
    return (
      <div>
        <Card list>
          <Form
            fields={fields.permissions.create}
            type="permission"
            handleChange={this.handleSearch}
            handleSubmit={this.handleAddPermission}
            hasButton={false}
            disabled={this.props.users.isFetching}
            getDispatch={this.handleFormDispatch}
          />
        </Card>
        {!this.props.users.isFetching &&
          this.props.users.didInvalidate && (
            <Card list>
              <Notification type="danger">
                {this.props.users.error}
              </Notification>
            </Card>
          )}
        {this.state.search !== false &&
          this.state.items.map((item) => (
            <Card
              list
              key={item.name}
              handleClick={() => {
                this.handleItemClick(item);
              }}
            >
              <strong>{item.title || item.name}</strong>
              <br />
              {item.description}
            </Card>
          ))}
        {this.state.search === false && (
          <Card list>
            <Notification type="default">
              Start typing to find your permission, and then click on it to
              assign it
            </Notification>
          </Card>
        )}
        {this.state.items.length === 0 && (
          <Card list>
            <Notification type="default">
              No relevant permissions found
            </Notification>
          </Card>
        )}
      </div>
    );
  }
}

const mapsStateToProps = (state) => ({
  users: state.users,
});

export default connect(mapsStateToProps)(PermissionForm);
